import { AccountCircleOutlined, HomeRounded } from "@mui/icons-material";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useCurrentUser } from "../hooks";
import ProfilePicture from "./ProfilePicture";

import "./nav_wrapper.scss";

interface Props {
  children: ReactNode;
}

const NavWrapper = ({ children }: Props) => {
  const currentUser = useCurrentUser();

  return (
    <>
      <div id="nav">
        <Link to="/">
          <HomeRounded fontSize="large" />
        </Link>
        <Link to="/account">
          {currentUser?.data !== undefined ? (
            <ProfilePicture path={currentUser?.data.profilePic} />
          ) : (
            <AccountCircleOutlined fontSize="large" />
          )}
        </Link>
      </div>
      {children}
    </>
  );
};

export default NavWrapper;
